export { default } from "@views/UnsupportedChain";
